import { AnalyticsTypes } from '../../middleware/google-analytics';
import { ActionTypes } from './constants';

export const changeInsurance = payload => ({
    type: ActionTypes.CHANGE_INSURANCE,
    payload,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: 'Profile',
            action: 'Change Insurance',
            label: `${payload.carrierId}:${payload.planId}`,
        },
    },
});
